import { cn } from '@/lib/utils'

interface PopularSearch {
  id: string
  query: string
  rank: number
}

interface PopularSearchesProps {
  searches: PopularSearch[]
  onSearchClick: (query: string) => void
  className?: string
}

export function PopularSearches({ 
  searches, 
  onSearchClick,
  className 
}: PopularSearchesProps) {
  if (searches.length === 0) {
    return (
      <div className={cn("px-4 py-6 border-t border-[#F5F5F5]", className)}>
        <h2 className="text-[16px] font-semibold text-[#222222] mb-4">인기 검색어</h2>
        <p className="text-[14px] text-[#999999] text-center py-8">
          인기 검색어를 준비 중입니다
        </p>
      </div>
    )
  }

  return (
    <div className={cn("px-4 py-6 border-t border-[#F5F5F5]", className)}>
      <h2 className="text-[16px] font-semibold text-[#222222] mb-4">인기 검색어</h2>
      
      <div className="space-y-3">
        {searches.map((search) => (
          <button
            key={search.id}
            onClick={() => onSearchClick(search.query)}
            className="w-full flex items-center gap-3 p-0 bg-transparent border-none cursor-pointer hover:bg-[#F5F5F5] transition-colors rounded-lg py-2 -mx-2 px-2"
          >
            <span className="text-[16px] font-medium text-[#86DB89] min-w-[20px] text-center">
              {search.rank}
            </span>
            <span className="text-[14px] text-[#222222] text-left flex-1">
              {search.query}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}